"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmutableDirectory = exports.Directory = exports.File = exports.DirNode = exports.MutableNode = exports.BaseNode = exports.createNode = exports.NodeType = void 0;
const ts_mixer_1 = require("ts-mixer");
const Id_1 = require("../Id");
const Tree_1 = require("./Tree");
const errors_1 = require("./errors");
var NodeType;
(function (NodeType) {
    NodeType[NodeType["File"] = 0] = "File";
    NodeType[NodeType["Directory"] = 1] = "Directory";
})(NodeType || (exports.NodeType = NodeType = {}));
/** Create an FSNode from a TreeNode in {@link TreeReplica}. */
function createNode(opts, tree) {
    if (opts.type === NodeType.File) {
        return new File(opts, tree);
    }
    if (opts.parentId) {
        return new Directory(opts, tree);
    }
    return new ImmutableDirectory(opts, tree);
}
exports.createNode = createNode;
class BaseNode {
    /** Unique id of the node. */
    id;
    /** Type of the node. */
    type;
    /** Parent id of the node. */
    parentId;
    /** Name of the FS entry. */
    name;
    /** A reference to the tree. */
    tree;
    constructor(opts, tree) {
        this.id = opts.id;
        this.type = opts.type;
        this.name = opts.name ?? undefined;
        this.parentId = opts.parentId ?? undefined;
        this.tree = tree;
    }
    get parent() {
        if (!this.parentId) {
            return undefined;
        }
        else {
            const directory = this.tree.nodes.get(this.parentId);
            if (directory?.isDirNode()) {
                return directory;
            }
            return undefined;
        }
    }
    get path() {
        if (!this.parentId)
            return "/";
        if (this.parentId === Tree_1.ROOT_ID)
            return `/${this.name}`;
        return this.parent.path.concat(`/${this.name}`);
    }
    /** Returns whether this node is a {@link File}. */
    isFile() {
        return (0, ts_mixer_1.hasMixin)(this, File);
    }
    /**
     * Returns whether this node is a {@link DirNode}.
     */
    isDirNode() {
        return (0, ts_mixer_1.hasMixin)(this, DirNode);
    }
    /**
     * Returns whether this node is a {@link Directory}.
     *
     * This does *not* include immutable directories like {@link ROOT}.
     * To identify {@link Directory} or {@link ImmutableDirectory}, use {@link isDirNode}.
     */
    isDirectory() {
        return (0, ts_mixer_1.hasMixin)(this, Directory);
    }
    /** Returns whether this node is a {@link MutableNode}. */
    isMutable() {
        return (0, ts_mixer_1.hasMixin)(this, MutableNode);
    }
    /** Returns whether this node is an {@link ImmutableDirectory}. */
    isImmutableDirectory() {
        return (0, ts_mixer_1.hasMixin)(this, ImmutableDirectory);
    }
}
exports.BaseNode = BaseNode;
/**
 * A mixin providing methods for node modification such as moving, deleting,
 * and renaming.
 */
class MutableNode extends BaseNode {
    /** This node's parent node. */
    get parent() {
        return super.parent;
    }
    /** Move this node to the provided directory node. */
    move(parent, name) {
        this.tree.moveNode(this.id, parent.id, name);
    }
    /**
     * Rename this node to the provided name.
     * Optionally, move it to the provided parent directory node.
     */
    rename(name) {
        this.tree.moveNode(this.id, this.parentId, name);
    }
    /** Delete this node. */
    delete() {
        this.tree.deleteNode(this.id);
    }
}
exports.MutableNode = MutableNode;
/** A mixin providing methods specific to directories. */
class DirNode extends BaseNode {
    /** Returns an array of a node's children. */
    get children() {
        const children = [];
        const childMap = this.tree.children.get(this.id);
        if (!childMap)
            return children;
        for (const childId of childMap.keys()) {
            const child = this.tree.nodes.get(childId);
            (0, errors_1.nodeExists)(child, `Attempting to get non-existent child of ${this}.`);
            children.push(child);
        }
        return children;
    }
    /** Find a child node by name */
    getChildByName(name) {
        const childMap = this.tree.children.get(this.id);
        if (!childMap)
            return undefined;
        const childId = childMap.getKey(name);
        if (!childId)
            return undefined;
        return this.tree.nodes.get(childId);
    }
    /** Create a file within this directory. */
    createFileWithId(id, name) {
        const node = createNode({ id, type: NodeType.File, name, parentId: this.id }, this.tree);
        this.tree._addNode(node);
        return this.tree.nodes.get(id);
    }
    createFile(name) {
        const id = (0, Id_1.newId)();
        return this.createFileWithId(id, name);
    }
    /** Create a directory within this directory. */
    createDirectoryWithId(id, name) {
        const node = createNode({ id, type: NodeType.Directory, name, parentId: this.id }, this.tree);
        this.tree._addNode(node);
        return this.tree.nodes.get(id);
    }
    /** Create a directory within this directory. */
    createDirectory(name) {
        const id = (0, Id_1.newId)();
        return this.createDirectoryWithId(id, name);
    }
}
exports.DirNode = DirNode;
class File extends MutableNode {
}
exports.File = File;
class Directory extends (0, ts_mixer_1.Mixin)(MutableNode, DirNode) {
}
exports.Directory = Directory;
class ImmutableDirectory extends DirNode {
    get parent() {
        return super.parent;
    }
}
exports.ImmutableDirectory = ImmutableDirectory;
//# sourceMappingURL=data:application/json;base64,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